module.exports = __webpack_public_path__ + "9947c8b7e59d76726e1f2a79ceece9bc.fbx";